import { useTheme } from "react-native-paper";
import type theme from "./theme";

export const useAppTheme = () => useTheme<typeof theme>();
